// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7b918e767b89298aaf8c","655":"e2c925a95c0640c89737"}[chunkId] + ".js";
};